import { render, staticRenderFns } from "./ApprovalStep.vue?vue&type=template&id=eb712e12&"
import script from "./ApprovalStep.vue?vue&type=script&lang=js&"
export * from "./ApprovalStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports